module.exports = __webpack_public_path__ + "static/europeanBannerSwiss-Map-Mobile-dfd6f2f850a03e71caacf974e112437e.png";